export const GET_INDUSTRIES = 'GET_INDUSTRIES';
export const REDUCE_INDUSTRIES = 'REDUCE_INDUSTRIES';
